import styled from "styled-components";

export const IconActive = styled.img`
  height: ${(props) => `px`};
  width: ${(props) => `px`};
  filter: invert(68%) sepia(50%) saturate(7123%) hue-rotate(194deg)
    brightness(95%) contrast(93%);
`;

export const Icons = styled.img`
  height: ${(props) => `px`};
  width: ${(props) => `px`};
`;

export const ContainerLinks = styled.div`
  display: flex;
  justify-content: space-between;
`;
